/**
 * Input form component.
 * Manages the JSON textarea and hash input.
 */

export interface FormState {
  jsonText: string;
  expectedHash: string;
}

export function initInputForm(): {
  getState: () => FormState;
  setState: (state: Partial<FormState>) => void;
  clear: () => void;
  setLoading: (loading: boolean) => void;
} {
  const txJson = document.getElementById('tx-json') as HTMLTextAreaElement;
  const expectedHash = document.getElementById('expected-hash') as HTMLInputElement;
  const verifyBtn = document.getElementById('verify-btn') as HTMLButtonElement;

  return {
    getState() {
      return {
        jsonText: txJson.value.trim(),
        expectedHash: expectedHash.value.trim(),
      };
    },

    setState(state) {
      if (state.jsonText !== undefined) txJson.value = state.jsonText;
      if (state.expectedHash !== undefined) expectedHash.value = state.expectedHash;
    },

    clear() {
      txJson.value = '';
      expectedHash.value = '';
    },

    setLoading(loading) {
      verifyBtn.disabled = loading;
      verifyBtn.innerHTML = loading
        ? '<span class="spinner"></span>Verifying...'
        : 'Verify Transaction';
    },
  };
}
